import { Form } from "react-bootstrap";
import { CustomInputTextArea } from "../../common/formControls";

const ConfirmSignature = ({ setPostData, postData }) => {

  return (
    <>
      <div className="edit-card p-3" id="signatureEditCard">
        <p className="sub_heading black">Add Signature Text</p>
        
        <CustomInputTextArea 
            name="signature"
              placeholder="Enter Signature Text"
              required={true}
              isFormControl
              value={postData?.leaseApplicationTemplateSections?.Signature?.clause}
              onChange={(e) => { setPostData({ ...postData, leaseApplicationTemplateSections: { ...postData.leaseApplicationTemplateSections, Signature: { ...postData.leaseApplicationTemplateSections.Signature, clause: e.target.value } } }) }}
              rows={3}
              isError={undefined}
              errorMessage={undefined}
              myClassName="normal_text "
              width="343px"
        />
      </div>
    </>
  );
};

export default ConfirmSignature;
